import React from "react";
import {Col, Row} from "react-bootstrap";
import {SvgIconComponent} from "@Components/Elements";



import "./index.scss";


type UserDashboardSecurityCardComponentProps = {
    cardIcon: string;
    cardTitle: string;
    cardDescription: string;
};


export const UserDashboardSecurityCardComponent:React.FC<UserDashboardSecurityCardComponentProps> = ({
    cardIcon, cardTitle, cardDescription
}) => {

    return (
        <Col xs={6} lg={'auto'} className={'user-dashboard-security-card-component'}>
            <Row className={'user-dashboard-security-card-component__content'}>
                <Col xs={12} className={'user-dashboard-security-card-component__card-header'}>
                    <SvgIconComponent iconSource={cardIcon} className={'card-header-icon'} />
                    <span className={'card-header-text'}>{cardTitle}</span>
                </Col>
                <Col xs={12} className={'user-dashboard-security-card-component__card-description'}>
                    <span>{cardDescription}</span>
                </Col>
            </Row>
        </Col>
    );

};


export default UserDashboardSecurityCardComponent;
